import MyInsurance from './MyInsurance'

export default MyInsurance
